import { useTranslation } from "react-i18next";
import { Button, Upload } from "antd";
import fileUpload from "../../../assets/svg/fileUpload.svg";

const UploadDropZone = ({ data }) => {
  const { t } = useTranslation();
  const {
    dragActive,
    uploading,
    isOverLimit,
    handleDragIn,
    handleDragOut,
    handleDrag,
    handleDrop,
    uploadProps,
  } = data;

  return (
    <div
      className={`upload-drop-area ${dragActive ? "drag-active" : ""} ${
        uploading ? "uploading" : ""
      } ${isOverLimit ? "over-limit" : ""}`}
      onDragEnter={handleDragIn}
      onDragLeave={handleDragOut}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <div
        className={`upload-icon-container ${dragActive ? "drag-hover" : ""}`}
      >
        <img src={fileUpload} />
      </div>

      <div className="upload-text-content">
        <div className="upload-default-text">
          <h3
            className={`upload-title ${
              dragActive ? "drag-title" : "default-title"
            }`}
          >
            {t("uploadZone.acceptedFormats")}
          </h3>
          <p className="upload-subtitle">{t("uploadZone.instruction")}</p>

          <Upload {...uploadProps}>
            <Button disabled={uploading || isOverLimit} type="link">
              {t("uploadZone.clickHere")}
            </Button>
          </Upload>
        </div>
      </div>

      <Upload {...uploadProps} className="upload-hidden">
        <div className="upload-hidden-area" />
      </Upload>

      {dragActive && !isOverLimit && (
        <div className="upload-particles">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
        </div>
      )}
    </div>
  );
};

export default UploadDropZone;
